<template>
  <backbar-page-layout
    v-if="canPerform('authcore.users.create')"
    hide-profile
    :loading="loading"
    title="user_create.title"
    back-title="user_create.text.back_title"
  >
    <template #alert>
      <b-alert
        variant="info"
        :show="loading"
        class="web-alert-style web-alert-absolute text-center rounded-0"
      >
        <span class="align-middle">{{ $t('status.info.loading') }}</span>
      </b-alert>
      <b-alert
        variant="danger"
        show
        v-if="error !== undefined"
        class="web-alert-style web-alert-absolute text-center rounded-0"
      >
        <i18n path="status.error.creating" tag="span" class="align-middle">
          <span place="message">{{ error.message }}</span>
        </i18n>
      </b-alert>
    </template>
    <b-container class="mt-5">
      <!-- TODO: Put the loading / error messages into their corresponding places -->
      <h3 class="font-weight-light border-bottom pb-3">{{ $t('user_create.text.profile') }}</h3>
      <b-form @submit="createUser">
        <b-bsq-input
          separate
          v-model="displayName"
          :disabled="loading"
          :label="$t('user_create.input.label.name')"
          class="my-5 w-60"
        />
        <b-bsq-input
          separate
          v-model="username"
          :state="usernameErrorState"
          aria-describedby="usernameError"
          :disabled="loading"
          :label="$t('user_create.input.label.username')"
          class="my-5 w-60"
          autocomplete="username"
        >
          <b-form-invalid-feedback id="usernameError">
            {{ $t(usernameErrorContent) }}
          </b-form-invalid-feedback>
        </b-bsq-input>
        <!-- TODO: Email, phone or contact field should be in condition to the server setting -->
        <b-form-contact-input
          separate
          v-model="contact"
          :state="contactErrorState"
          aria-describedby="contactError"
          :label="$t('user_create.input.label.email_or_mobile')"
          class="my-5 w-60"
        >
          <b-form-invalid-feedback id="contactError">
            {{ $t(contactErrorContent) }}
          </b-form-invalid-feedback>
        </b-form-contact-input>
        <b-bsq-input
          separate
          type="password"
          v-model="password"
          :disabled="loading"
          :label="$t('user_create.input.label.password')"
          class="my-5 w-60"
        />
        <!-- <h3 class="font-weight-light border-bottom pb-3">{{ $t('user_create.text.generate_password') }}</h3>
             <div class="border w-60 d-flex p-4 my-5">
             <textarea
             id="password"
             :value="generatedPassword"
             class="pt-3 text-center border-0"
             style="resize: none; text-overflow: ellipsis; white-space: pre; overflow-x: hidden;"
             readonly
             />
             <b-button
             variant="outline-primary"
             class="ml-auto align-self-center"
             @click="generatePassword"
             >
             {{ $t('user_create.button.generate') }}
             </b-button> -->
        <!-- TODO: Provide animation -->
        <!-- <b-button
             variant="outline-primary"
             class="ml-5 align-self-center"
             @click="copyToClipboard"
             >
             {{ $t('user_create.button.copy') }}
             </b-button>
             </div> -->
        <b-button
          :disabled="loading"
          type="submit"
          variant="primary"
          class="px-5"
        >
          {{ $t('user_create.button.create_user') }}
        </b-button>
      </b-form>
    </b-container>
  </backbar-page-layout>
  <b-alert v-else variant="danger" show>
    <i18n path="status.error.not_authorized" tag="div">
      <span place="page">{{ $t('general.create_user') }}</span>
    </i18n>
  </b-alert>
</template>

<script>
import { mapState } from 'vuex'

import store from '@/store'

import BackbarPageLayout from '@/components/BackbarPageLayout.vue'
import { isPossibleNumber } from 'libphonenumber-js'

export default {
  name: 'UserCreate',
  components: {
    BackbarPageLayout
  },
  data () {
    return {
      username: '',
      email: '',
      phone: '',
      contact: '',
      displayName: '',
      password: ''
    }
  },
  computed: {
    ...mapState('management/usersList/createUserForm', [
      'loading',
      'error',
      'usernameError',
      'contactError'
    ]),
    usernameErrorState () {
      return this.usernameError === undefined ? null : false
    },
    usernameErrorContent () {
      return this.usernameError === undefined ? 'general.blank' : this.usernameError
    },
    contactErrorState () {
      return this.contactError === undefined ? null : false
    },
    contactErrorContent () {
      return this.contactError === undefined ? 'general.blank' : this.contactError
    }
  },

  created () {},
  mounted () {},
  updated () {},
  destroyed () {
    store.commit('management/usersList/createUserForm/CLEAR_STATES')
  },

  methods: {
    async createUser (e) {
      e.preventDefault()
      try {
        const { username, contact, password, displayName } = this
        const userInformation = {
          username: username,
          password: password,
          displayName: displayName
        }
        if (isPossibleNumber(contact)) {
          userInformation.phone = contact
        } else {
          userInformation.email = contact
        }
        await store.dispatch('management/usersList/createUserForm/create', userInformation)
      } catch (err) {
        console.error(err)
      }
    }
    /* generatePassword () {
     *   const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890'
     *   const length = 12
     *   let password = ""
     *   for (let x = 0; x < length; x++) {
     *     let i = Math.floor(Math.random() * chars.length)
     *     password += chars.charAt(i)
     *   }
     *   this.generatedPassword = password
     * },
     * copyToClipboard () {
     *   const secret = document.getElementById('password')
     *   secret.select()
     *   document.execCommand('copy')
     * } */
  }
}
</script>
